import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	sbTablePagination: {
		borderTop: "1px solid #E0E0E0",
	},
}));
